/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/redirect"/>

export function redirectUnauthorized(response: Response) : Response{
    if (response.status === 401){
        const frm = (window.frames as any).logoutFrm;
        if (frm)
            frm.location = "TokenRenewal/Index";
    }
    return response;
}